import { render, staticRenderFns } from "./WalmartShareModal.vue?vue&type=template&id=4c421344"
import script from "./WalmartShareModal.vue?vue&type=script&lang=js"
export * from "./WalmartShareModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports